const filters = document.querySelectorAll('.js-search-filter'),
    results = document.querySelectorAll('.js-search-result');

export function init() {
    // Add click event to filters
    filters.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();

            // Activate this filter, deactivate others
            let activeFilter = document.querySelector('.js-search-filters .active');

            if (activeFilter) {
                activeFilter.classList.remove('active');
            }

            // If active filter was clicked on, let all deactivate
            if (el === activeFilter) {

              results.forEach(result => {
                result.classList.remove('hide');
              }); 

            } else {

                // Add active class
                el.classList.add('active');

                // Hide all results that don't have this entry type
                results.forEach(result => {
                    if (result.dataset.type !== el.dataset.type) {
                        result.classList.add('hide');
                    } else {
                        result.classList.remove('hide');
                    }
                });
            }
        });
    });
}
